import type { ReactNode } from "react";
import { Box, Row, type RowProps, TextWithTooltip } from "@hightouch/htui";
import { RouterLink } from "src/router";

const ROW_STYLES: RowProps = {
  align: "center",
  gap: 3,
  width: "100%",
  minWidth: 0,
  px: 3,
  py: 1.5,
  borderRadius: "md",
  textAlign: "left",
  _hover: { bg: "base.lightBackground" },
  _focusVisible: { boxShadow: "outline", outline: "none" },
};

type Props = {
  icon: ReactNode;
  label: string;
  ariaLabel?: string;
  rightContent?: ReactNode;
} & (
  | { onClick: () => void; href?: never; isExternal?: never }
  | { href: string; isExternal?: boolean; onClick?: never }
);

export const ContextRow = ({
  icon,
  label,
  ariaLabel,
  rightContent,
  onClick,
  href,
  isExternal,
}: Props) => {
  const content = (
    <>
      {icon}
      <Box flex={1} minWidth={0}>
        <TextWithTooltip>{label}</TextWithTooltip>
      </Box>
      {rightContent}
    </>
  );

  if (href !== undefined) {
    return (
      <Row
        as={RouterLink}
        to={href}
        {...(isExternal && { target: "_blank", rel: "noreferrer" })}
        aria-label={ariaLabel}
        {...ROW_STYLES}
      >
        {content}
      </Row>
    );
  }

  return (
    <Row
      as="button"
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      {...ROW_STYLES}
    >
      {content}
    </Row>
  );
};
